var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
import { deserialize, struct, types as t } from 'utilium';
let LongFormDate = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let __year_decorators;
    let __year_initializers = [];
    let __year_extraInitializers = [];
    let __month_decorators;
    let __month_initializers = [];
    let __month_extraInitializers = [];
    let __day_decorators;
    let __day_initializers = [];
    let __day_extraInitializers = [];
    let __hour_decorators;
    let __hour_initializers = [];
    let __hour_extraInitializers = [];
    let __minute_decorators;
    let __minute_initializers = [];
    let __minute_extraInitializers = [];
    let __second_decorators;
    let __second_initializers = [];
    let __second_extraInitializers = [];
    let __centisecond_decorators;
    let __centisecond_initializers = [];
    let __centisecond_extraInitializers = [];
    let _offsetFromGMT_decorators;
    let _offsetFromGMT_initializers = [];
    let _offsetFromGMT_extraInitializers = [];
    var LongFormDate = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __year_decorators = [t.char(4)];
            __month_decorators = [t.char(2)];
            __day_decorators = [t.char(2)];
            __hour_decorators = [t.char(2)];
            __minute_decorators = [t.char(2)];
            __second_decorators = [t.char(2)];
            __centisecond_decorators = [t.char(2)];
            _offsetFromGMT_decorators = [(_a = t).uint8.bind(_a)];
            __esDecorate(null, null, __year_decorators, { kind: "field", name: "_year", static: false, private: false, access: { has: obj => "_year" in obj, get: obj => obj._year, set: (obj, value) => { obj._year = value; } }, metadata: _metadata }, __year_initializers, __year_extraInitializers);
            __esDecorate(null, null, __month_decorators, { kind: "field", name: "_month", static: false, private: false, access: { has: obj => "_month" in obj, get: obj => obj._month, set: (obj, value) => { obj._month = value; } }, metadata: _metadata }, __month_initializers, __month_extraInitializers);
            __esDecorate(null, null, __day_decorators, { kind: "field", name: "_day", static: false, private: false, access: { has: obj => "_day" in obj, get: obj => obj._day, set: (obj, value) => { obj._day = value; } }, metadata: _metadata }, __day_initializers, __day_extraInitializers);
            __esDecorate(null, null, __hour_decorators, { kind: "field", name: "_hour", static: false, private: false, access: { has: obj => "_hour" in obj, get: obj => obj._hour, set: (obj, value) => { obj._hour = value; } }, metadata: _metadata }, __hour_initializers, __hour_extraInitializers);
            __esDecorate(null, null, __minute_decorators, { kind: "field", name: "_minute", static: false, private: false, access: { has: obj => "_minute" in obj, get: obj => obj._minute, set: (obj, value) => { obj._minute = value; } }, metadata: _metadata }, __minute_initializers, __minute_extraInitializers);
            __esDecorate(null, null, __second_decorators, { kind: "field", name: "_second", static: false, private: false, access: { has: obj => "_second" in obj, get: obj => obj._second, set: (obj, value) => { obj._second = value; } }, metadata: _metadata }, __second_initializers, __second_extraInitializers);
            __esDecorate(null, null, __centisecond_decorators, { kind: "field", name: "_centisecond", static: false, private: false, access: { has: obj => "_centisecond" in obj, get: obj => obj._centisecond, set: (obj, value) => { obj._centisecond = value; } }, metadata: _metadata }, __centisecond_initializers, __centisecond_extraInitializers);
            __esDecorate(null, null, _offsetFromGMT_decorators, { kind: "field", name: "offsetFromGMT", static: false, private: false, access: { has: obj => "offsetFromGMT" in obj, get: obj => obj.offsetFromGMT, set: (obj, value) => { obj.offsetFromGMT = value; } }, metadata: _metadata }, _offsetFromGMT_initializers, _offsetFromGMT_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            LongFormDate = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        _year = __runInitializers(this, __year_initializers, '');
        get year() {
            return parseInt(this._year);
        }
        set year(value) {
            this._year = value.toFixed();
        }
        _month = (__runInitializers(this, __year_extraInitializers), __runInitializers(this, __month_initializers, ''));
        get month() {
            return parseInt(this._month);
        }
        set month(value) {
            this._month = value.toFixed();
        }
        _day = (__runInitializers(this, __month_extraInitializers), __runInitializers(this, __day_initializers, ''));
        get day() {
            return parseInt(this._day);
        }
        set day(value) {
            this._day = value.toFixed();
        }
        _hour = (__runInitializers(this, __day_extraInitializers), __runInitializers(this, __hour_initializers, ''));
        get hour() {
            return parseInt(this._hour);
        }
        set hour(value) {
            this._hour = value.toFixed();
        }
        _minute = (__runInitializers(this, __hour_extraInitializers), __runInitializers(this, __minute_initializers, ''));
        get minute() {
            return parseInt(this._minute);
        }
        set minute(value) {
            this._minute = value.toFixed();
        }
        _second = (__runInitializers(this, __minute_extraInitializers), __runInitializers(this, __second_initializers, ''));
        get second() {
            return parseInt(this._second);
        }
        set second(value) {
            this._second = value.toFixed();
        }
        _centisecond = (__runInitializers(this, __second_extraInitializers), __runInitializers(this, __centisecond_initializers, ''));
        get centisecond() {
            return parseInt(this._centisecond);
        }
        set centisecond(value) {
            this._centisecond = value.toFixed();
        }
        offsetFromGMT = (__runInitializers(this, __centisecond_extraInitializers), __runInitializers(this, _offsetFromGMT_initializers, void 0));
        get date() {
            return new Date(this.year, this.month, this.day, this.hour, this.minute, this.second, this.centisecond * 10);
        }
        constructor() {
            __runInitializers(this, _offsetFromGMT_extraInitializers);
        }
    };
    return LongFormDate = _classThis;
})();
export { LongFormDate };
let ShortFormDate = (() => {
    var _a, _b, _c, _d, _e, _f, _g;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _year_decorators;
    let _year_initializers = [];
    let _year_extraInitializers = [];
    let _month_decorators;
    let _month_initializers = [];
    let _month_extraInitializers = [];
    let _day_decorators;
    let _day_initializers = [];
    let _day_extraInitializers = [];
    let _hour_decorators;
    let _hour_initializers = [];
    let _hour_extraInitializers = [];
    let _minute_decorators;
    let _minute_initializers = [];
    let _minute_extraInitializers = [];
    let _second_decorators;
    let _second_initializers = [];
    let _second_extraInitializers = [];
    let _offsetFromGMT_decorators;
    let _offsetFromGMT_initializers = [];
    let _offsetFromGMT_extraInitializers = [];
    var ShortFormDate = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _year_decorators = [(_a = t).uint8.bind(_a)];
            _month_decorators = [(_b = t).uint8.bind(_b)];
            _day_decorators = [(_c = t).uint8.bind(_c)];
            _hour_decorators = [(_d = t).uint8.bind(_d)];
            _minute_decorators = [(_e = t).uint8.bind(_e)];
            _second_decorators = [(_f = t).uint8.bind(_f)];
            _offsetFromGMT_decorators = [(_g = t).uint8.bind(_g)];
            __esDecorate(null, null, _year_decorators, { kind: "field", name: "year", static: false, private: false, access: { has: obj => "year" in obj, get: obj => obj.year, set: (obj, value) => { obj.year = value; } }, metadata: _metadata }, _year_initializers, _year_extraInitializers);
            __esDecorate(null, null, _month_decorators, { kind: "field", name: "month", static: false, private: false, access: { has: obj => "month" in obj, get: obj => obj.month, set: (obj, value) => { obj.month = value; } }, metadata: _metadata }, _month_initializers, _month_extraInitializers);
            __esDecorate(null, null, _day_decorators, { kind: "field", name: "day", static: false, private: false, access: { has: obj => "day" in obj, get: obj => obj.day, set: (obj, value) => { obj.day = value; } }, metadata: _metadata }, _day_initializers, _day_extraInitializers);
            __esDecorate(null, null, _hour_decorators, { kind: "field", name: "hour", static: false, private: false, access: { has: obj => "hour" in obj, get: obj => obj.hour, set: (obj, value) => { obj.hour = value; } }, metadata: _metadata }, _hour_initializers, _hour_extraInitializers);
            __esDecorate(null, null, _minute_decorators, { kind: "field", name: "minute", static: false, private: false, access: { has: obj => "minute" in obj, get: obj => obj.minute, set: (obj, value) => { obj.minute = value; } }, metadata: _metadata }, _minute_initializers, _minute_extraInitializers);
            __esDecorate(null, null, _second_decorators, { kind: "field", name: "second", static: false, private: false, access: { has: obj => "second" in obj, get: obj => obj.second, set: (obj, value) => { obj.second = value; } }, metadata: _metadata }, _second_initializers, _second_extraInitializers);
            __esDecorate(null, null, _offsetFromGMT_decorators, { kind: "field", name: "offsetFromGMT", static: false, private: false, access: { has: obj => "offsetFromGMT" in obj, get: obj => obj.offsetFromGMT, set: (obj, value) => { obj.offsetFromGMT = value; } }, metadata: _metadata }, _offsetFromGMT_initializers, _offsetFromGMT_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            ShortFormDate = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        /**
         * Years since 1990
         * @todo This may not be the correct size
         * @see https://wiki.osdev.org/ISO_9660
         */
        year = __runInitializers(this, _year_initializers, void 0);
        month = (__runInitializers(this, _year_extraInitializers), __runInitializers(this, _month_initializers, void 0));
        day = (__runInitializers(this, _month_extraInitializers), __runInitializers(this, _day_initializers, void 0));
        hour = (__runInitializers(this, _day_extraInitializers), __runInitializers(this, _hour_initializers, void 0));
        minute = (__runInitializers(this, _hour_extraInitializers), __runInitializers(this, _minute_initializers, void 0));
        second = (__runInitializers(this, _minute_extraInitializers), __runInitializers(this, _second_initializers, void 0));
        /**
         * Note: Timezone is ignored
         */
        offsetFromGMT = (__runInitializers(this, _second_extraInitializers), __runInitializers(this, _offsetFromGMT_initializers, void 0));
        get date() {
            return new Date(1900 + this.year, this.month - 1, this.day, this.hour, this.minute, this.second);
        }
        constructor() {
            __runInitializers(this, _offsetFromGMT_extraInitializers);
        }
    };
    return ShortFormDate = _classThis;
})();
export { ShortFormDate };
export function getShortFormDate(data) {
    const date = new ShortFormDate();
    deserialize(date, data);
    return date.date;
}
//# sourceMappingURL=utils.js.map